import Activity from 'pages/activity/Activity';
import Itinerary from 'pages/itinerary/Itinerary';
import ItineraryStatistics from 'pages/statistics/ItineraryStatistics';
import Login from 'pages/login/Login';
import LoginSuccessful from 'pages/login/LoginSuccessful';
import Logout from 'pages/logout/Logout';
import NotFound from 'pages/notFound/NotFound';
import CountryContextSelection from 'pages/countrySelection/CountryContextSelection';
import Unauthorized from 'pages/unauthorized/Unauthorized';
import Settings from 'pages/settings/Settings';
import ItineraryComparison from 'pages/itineraryComparison/ItineraryComparison';
import CapacityPlanning from 'pages/capacityPlanning/CapacityPlanning';
import { ReactNode } from 'react';
import { PermissionName } from './core/permissions/Permissions';
import { Navigate } from 'react-router-dom';
import Ooh from './pages/ooh/Ooh';

export type RouteMetadata = {
  path: string;
  element: ReactNode;
  isPrivate: boolean;
  isIndex: boolean;
  order: number;
  showInMenu: boolean;
  displayName?: string;
  isCatchAll?: boolean;
  permissionsRequired?: PermissionName;
  exactMatch?: boolean;
};

const routes: RouteMetadata[] = [
  {
    path: 'login',
    element: <Login />,
    isIndex: false,
    isPrivate: false,
    showInMenu: false,
    order: 0,
  },
  {
    path: 'login-successful',
    element: <LoginSuccessful />,
    isIndex: false,
    isPrivate: false,
    showInMenu: false,
    order: 0,
  },
  {
    path: 'logout',
    element: <Logout />,
    isIndex: false,
    showInMenu: true,
    order: 8,
    isPrivate: false,
    displayName: 'Logout',
  },
  {
    path: 'unauthorized',
    element: <Unauthorized />,
    isIndex: false,
    isPrivate: false,
    showInMenu: false,
    order: 0,
  },
  {
    path: 'country-selection',
    element: <CountryContextSelection />,
    isIndex: false,
    isPrivate: false,
    showInMenu: false,
    order: 0,
  },
  {
    path: ':countryCode/itinerary-statistics',
    element: <ItineraryStatistics />,
    isIndex: false,
    showInMenu: true,
    order: 4,
    isPrivate: true,
    displayName: 'Statistics',
  },
  {
    path: ':countryCode/itinerary-comparison',
    element: <ItineraryComparison />,
    isIndex: false,
    isPrivate: true,
    showInMenu: true,
    order: 3,
    displayName: 'Itinerary Comparison',
  },
  {
    path: ':countryCode/activity',
    element: <Activity />,
    isIndex: false,
    isPrivate: true,
    showInMenu: true,
    order: 5,
    displayName: 'Activity',
  },
  {
    path: ':countryCode/settings',
    element: <Settings />,
    isIndex: false,
    isPrivate: true,
    showInMenu: true,
    order: 6,
    displayName: 'Settings',
    permissionsRequired: 'settings.edit',
  },
  {
    path: ':countryCode/capacity-planning',
    element: <CapacityPlanning />,
    isIndex: false,
    isPrivate: true,
    showInMenu: true,
    order: 7,
    displayName: 'Capacity planning',
    permissionsRequired: 'capacityPlanning.read',
  },
  {
    path: ':countryCode/ooh',
    element: <Ooh />,
    isIndex: false,
    isPrivate: true,
    showInMenu: true,
    order: 2,
    displayName: 'OOH',
  },
  {
    path: ':countryCode',
    element: <Itinerary />,
    isIndex: false,
    isPrivate: true,
    showInMenu: true,
    order: 1,
    displayName: 'Itinerary',
    exactMatch: true,
  },
  {
    path: '',
    element: <Navigate to="country-selection" />,
    isIndex: true,
    isPrivate: false,
    showInMenu: false,
    order: 0,
  },
  {
    path: '*',
    element: <NotFound />,
    isCatchAll: true,
    isPrivate: false,
    isIndex: false,
    showInMenu: false,
    order: 0,
  },
];

export default routes;
